export const policies = [
  {
    title: 'Abono',
    description: 'La reserva requiere un abono de $5.000 CLP. El abono no es reembolsable.',
  },
  {
    title: 'Cambios con anticipación',
    description:
      'Avisando con al menos 24 horas de anticipación puedes mantener tu abono y reagendar una vez.',
  },
  {
    title: 'Atrasos',
    description:
      'Existe una tolerancia de 10 minutos. Si tienes un inconveniente, comunícalo lo antes posible.',
  },
  {
    title: 'Inasistencia',
    description: 'Si no asistes a tu cita, la reserva y el abono se pierden.',
  },
  {
    title: 'Retiro y diseños',
    description:
      'El retiro de productos puede tener costo adicional. El precio final puede variar según el diseño y los servicios adicionales seleccionados.',
  },
];
